const fixDateFormatForSafari = (date) => {
  return date?.replace ? date?.replace(/-/g, "/") : date;
};

export default fixDateFormatForSafari;
